import { questionServiceQuestionBrandModalSliceDispatch } from "../../Constants/ReduxConstants";

const initialState = {
    open: false,
    pendingServiceBrandQuestions: [],
    selectedBrand: undefined,
    selectedService: undefined
}


export default function questionServiceQuestionBrandModalSlice(state = initialState, action) {
    switch (action.type) {
        case questionServiceQuestionBrandModalSliceDispatch.setOpen: {
            return {
                ...state,
                open: action.payload
            }
        }
        case questionServiceQuestionBrandModalSliceDispatch.setPendingServiceBrandQuestions: {
            return {
                ...state,
                pendingServiceBrandQuestions: action.payload
            }
        }
        case questionServiceQuestionBrandModalSliceDispatch.setSelectedBrand: {
            return {
                ...state,
                selectedBrand: action.payload
            }
        }
        case questionServiceQuestionBrandModalSliceDispatch.setSelectedService: {
            return {
                ...state,
                selectedService: action.payload
            }
        }
        
        default:
            return state
    }
}